import { Directive, Input } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
    selector: '[disableControl]',
    standalone: false
})
export class DisableControlSharedDirective {
  @Input() set disableControl(condition: boolean) {
    if (condition) {
      this.ngControl.control?.disable();
    } else {
      this.ngControl.control?.enable();
    }
  }
  
  constructor(public ngControl: NgControl) {
  }
}